import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableProductsView.
 * @extends JetView
 */
export default class tableProductsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var datos = [
            // Sample data for the datatable
            {
                Id: '01',
                Name: 'Primer',
                Route: 'Ruta 1',
                Version: '1',
                Type: 'null',
                IsActivate: 'A',
            },
            {
                Id: '02',
                Name: 'Segundo',
                Route: 'Ruta 2',
                Version: '2',
                Type: 'null',
                IsActivate: 'A',
            },
        ];
        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'ID', width: 200, sort: 'int' },
                { id: 'Name', header: _('Nombre'), width: 200, sort: 'int' },
                { id: 'Route', header: _('Ruta'), width: 200, sort: 'int' },
                {
                    id: 'Version',
                    header: _('Versión'),
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'Type',
                    header: _('Tipo'),
                    editor: 'combo', // Combo editor for Type
                    options: [
                        // Options for the combo
                        { id: 'null', value: _('Todos') },
                        { id: '1', value: _('Documento 1') },
                        { id: '2', value: _('Documento 2') },
                    ],
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'IsActivate',
                    header: _('Estado'),
                    editor: 'combo', // Combo editor for IsActivate
                    options: [
                        // Options for the combo
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 150,
                    sort: 'int',
                },
            ],
            footer: true, // Enable footer
            math: true, // Enable math functions
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for loading data
            url: devConfig.geturlApi() + '/UserManagement/GetRegisteredDocuments',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        this.on(this.app, 'registeredDocuments:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player
            );
        });
        var popup = webix.ui({
            // Create edit popup window
            view: 'window',
            id: 'editwin',
            head: 'Edit.. ',
            position: 'center',
            modal: true,
            body: {
                view: 'form',
                id: 'editform', // ID of the edit form
                elements: [
                    // Form elements
                    { view: 'text', label: 'ID', name: 'Id', readonly: true },
                    {
                        view: 'text',
                        label: _('Nombre'),
                        name: 'Name',
                        readonly: true,
                    },
                    {
                        view: 'text',
                        label: _('Ruta'),
                        name: 'Route',
                        readonly: true,
                    },
                    {
                        view: 'text',
                        label: _('Versión'),
                        name: 'Version',
                        readonly: true,
                    },
                    {
                        view: 'combo',
                        label: _('Tipo'),
                        name: 'Type',
                        options: [
                            // Options for Type combo
                            { id: 'null', value: _('Todos') },
                            { id: '1', value: _('Documento 1') },
                            { id: '2', value: _('Documento 2') },
                        ],
                    },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            // Options for IsActivate combo
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to update data
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RegisteredDocuments/UpdateRegisteredDocuments',
                                            '{"Id":' +
                                                values.Id +
                                                ',"Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                ',"Version":"' +
                                                values.Version +
                                                ',"Type":"' +
                                                values.Type +
                                                ', "IsActivate":"' +
                                                values.IsActivate +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _(
                                                            'Cell value was changed', // Show success message
                                                        ),
                                                    );
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide popup after save
                                },
                            },
                        ],
                    },
                ],
            },
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event listener for item double-click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
